import { Instagram } from "lucide-react";
import { INSTAGRAM_FEED } from "@/lib/api";
import { motion } from "framer-motion";

export default function InstagramGrid() {
  return (
    <section className="py-24 md:py-32 bg-[#F8F5F0]" data-testid="instagram-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="flex items-center gap-4 justify-center mb-4">
            <span className="divider-gold" />
            <a
              href="https://www.instagram.com/blisson.in"
              target="_blank"
              rel="noreferrer"
              className="overline hover:text-[#C9A961] transition-colors"
              data-testid="insta-handle-link"
            >
              @blisson.in
            </a>
            <span className="divider-gold" />
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl tracking-tighter font-light leading-[1.05]">
            Step inside the <em className="gold-text not-italic">studio</em>.
          </h2>
          <a
            href="https://www.instagram.com/blisson.in"
            target="_blank"
            rel="noreferrer"
            className="inline-block overline mt-5 hover:text-[#C9A961] transition-colors"
            data-testid="insta-follow-cta"
          >
            Follow on Instagram →
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 gap-2 md:gap-3">
          {INSTAGRAM_FEED.map((img, i) => (
            <motion.a
              key={i}
              href="https://www.instagram.com/blisson.in"
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className="group relative aspect-square overflow-hidden bg-white"
              data-testid={`insta-tile-${i}`}
            >
              <img src={img} alt={`Blisson Instagram studio post ${i + 1}`} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                <Instagram size={24} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" strokeWidth={1.4} />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
